import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavItemComponent } from '@components/master-layout/navs/components/nav-item/nav-item.component';
import { AuthenService } from '@core/authen/authen.service';
import { NewsMessagesHttpService } from '@core/http/news-messages-http.service';
import { SessionService } from '@core/session.service';
import { environment } from '@env/environment';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NavInterface } from '@shared/interfaces/nav.interface';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-nav-news-messages',
  templateUrl: './nav-news-messages.component.html',
  imports: [CommonModule, NavItemComponent],
})
export class NavNewsMessagesComponent implements OnInit {
  newsLength = 0;
  authenticated$: Observable<boolean>;

  navItem: NavInterface = {
    name: 'Messages',
    ngIcon: 'matChatBubbleOutline',
    route: environment.jipUrl.messages,
  };

  constructor(
    private readonly newsMessagesHttpService: NewsMessagesHttpService,
    private readonly sessionService: SessionService,
    private readonly authenService: AuthenService
  ) {}

  ngOnInit(): void {
    this.authenticated$ = this.authenService.authenticated();
    this.loadData();
  }

  loadData(): void {
    this.sessionService.apiReady$
      .pipe(untilDestroyed(this))
      .subscribe(apiReady => {
        if (apiReady) {
          this.loadItems();
        }
      });
  }

  loadItems(): void {
    this.authenticated$.subscribe(login => {
      if (!login) {
        return;
      }
      this.newsMessagesHttpService.getCounts().subscribe(counts => {
        this.newsLength = counts;
      });
    });
  }
}
